// removed by extract-text-webpack-plugin
module.exports = {"mobile-list":"alphabet__mobile-list___3x-KO","tablet-list":"alphabet__tablet-list___3v_Sv","item":"alphabet__item___27fSq","link":"alphabet__link___19xJP"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Person/Alphabet/alphabet.scss
// module id = 935
// module chunks = 0